import CollectionPlaceholderCode from "./CollectionPlaceholderCode"

export default CollectionPlaceholderCode